import React, { useEffect, useState, useRef } from "react";
import Select from "./Select";
import { isEmpty } from "lodash";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { navigate } from "gatsby"; //import navigate from gatsby
import {
	Container,
	Title,
	FilterBar,
	SelectWrapper,
	CardsContainer,
	LoadMore,
	ClearFilters,
	ClearFilterText,
	CrossIcon,
	NoResults,
} from "./styles";
import { addToDataLayer } from "@website-builder/utilities-index";
import Card from "./AliumniCard";
import VideoModalV2 from "../VideoModalV2";
import { FILTERS } from "@website-builder/utilities-index";

const Alumni = (props) => {
	const [currentPage, setcurrentPage] = useState(1);

	const handleLoadMore = (e) => {
		setcurrentPage(currentPage + 1);
	};
	const { title, filterData, pageLength = 1 } = props;

	//Get All Stories
	const [clearFilters, setClearFilters] = useState(Math.random());
	const [stories, setStories] = useState([]);
	const [filteredStories, setFilteredStories] = useState([]);
	const [filtersActive, setFiltersActive] = useState(null);
	const [videoUrl, setVideoUrl] = useState(null);
	const [showOptions, setShowOptions] = useState(false);

	//Perform initial sorting and remove the unwanted data from the stories object
	const ref = useRef(null);
	useEffect(() => {
		const allStories = [...props.stories, ...props.video_stories];
		//Sort the stories
		console.log("allStories", { allStories });
		const allSortedStories = allStories?.sort((a, b) => {
			return new Date(b?.published_at) - new Date(a?.published_at);
		});
		//Set sorted stories
		const storiesData = allSortedStories.map((s) => {
			//Return the story card data
			return {
				alumni_data: s.content?.alumni_data[0],
				filter_options: s.content?.filter_options[0],
				video_data: s.content?.videoUrl,
				full_slug: s.full_slug,
				//Object of the Card
			};
		});
		setStories(storiesData);
		setFilteredStories(storiesData);
		function handleClick(event) {
			if (ref.current && !ref.current.contains(event.target)) {
				setShowOptions(Math.random());
			}
		}
		window.addEventListener("mousedown", handleClick);
		return () => {
			window.removeEventListener("mousedown", handleClick);
		};
	}, []);

	//Update the filtersActive on every filter
	const handleFilterChange = (filtername, optionsSelected) => {
		const ActiveFilters = {
			...filtersActive,
			[filtername]: new Set(optionsSelected),
		};
		//keep the active filters in the list
		setFiltersActive(ActiveFilters);

		let filterredStories = [];
		let filterStrings = [];
		let activeFiltersForSegmentTracking = {};
		//Turn all the filters into strings of Filter array for Regex Search
		filterStrings = Object.keys(ActiveFilters).map((f) => {
			const toReturn = [...ActiveFilters[f]].join("|");

			// const segmentActivefilter =
			activeFiltersForSegmentTracking[f?.toLowerCase()?.split(" ")?.join("_")] =
				[...ActiveFilters[f]].join(",");
			//Check if the filters are empty
			if (toReturn.length > 0) {
				return toReturn;
			} else return null;
		});
		//Make sure the filter strings are not null
		filterStrings = filterStrings.filter((s) => s);

		//If the filterStrings are empty then set the default sorted stories
		if (isEmpty(filterStrings)) {
			setFiltersActive(null);
			return setFilteredStories(stories);
		}

		filterredStories = stories.map((m) => {
			//String to be searched
			const searchString = JSON.stringify(m.filter_options);

			// Regex Search for different Filter Categories
			const searchResult = filterStrings.map((filter) => {
				//build the Regex
				const searchRegex = new RegExp(filter, `i`);
				if (searchString.search(searchRegex) > 0) {
					return m;
				}
				return null;
			});
			let nullMatch = searchResult.filter((res) => res === null);

			if (!nullMatch.length) {
				return m;
			}
			return null;
		});
		const finalFilteredStories = filterredStories.filter((f) => f);
		//Trigger Segment Event through GTM
		addToDataLayer({
			event: "roi_calculate",
			...activeFiltersForSegmentTracking,
		});
		//Set Filterred Stories
		setFilteredStories(finalFilteredStories);
	};

	const handleClearFilters = () => {
		setFilteredStories(stories);
		setClearFilters(Math.random());
		setFiltersActive(null);
	};
	const handleCardClick = (s) => {
		if (s.video_data) {
			// console.log("Will play the video url ", s.video_data);
			//set the Video URL for the Modal
			setVideoUrl(s.video_data);
		} else {
			//Redirect to the Story URL
			navigate(`/${s.full_slug}`);
		}
	};
	return (
		<Container>
			<Title>{title}</Title>
			<FilterBar ref={ref}>
				{Object.keys(FILTERS).map((item) => {
					return (
						<SelectWrapper>
							<Select
								onChange={(e) => {
									handleFilterChange(FILTERS[item].title, e);
								}}
								head={{ label: FILTERS[item].label }}
								options={filterData[0][FILTERS[item].key]}
								clear={clearFilters}
								showOptions={showOptions}
							></Select>
						</SelectWrapper>
					);
				})}
				{filtersActive && (
					<ClearFilters onClick={() => handleClearFilters()}>
						<CrossIcon>
							<CloudinaryImage
								lazyload
								url={
									"https://res.cloudinary.com/springboard-images/image/upload/v1633347845/Vector.png"
								}
								sizes={{ default: { height: 50 } }}
							/>
						</CrossIcon>

						<ClearFilterText>Clear All Filters</ClearFilterText>
					</ClearFilters>
				)}
			</FilterBar>
			<CardsContainer>
				{filteredStories.map((s, index) => {
					const totalItems = pageLength * currentPage;
					if (totalItems < index + 1) {
						return;
					}
					return (
						<Card
							onClick={() => {
								handleCardClick(s);
							}}
							isOnlyVideoCard={s.video_data && true}
							key={String(index)}
							data={s}
							id={String(index)}
						/>
					);
				})}
				<VideoModalV2
					show={!!videoUrl}
					url={videoUrl}
					onModalClose={() => setVideoUrl(null)}
				></VideoModalV2>
			</CardsContainer>
			{!filteredStories.length && (
				<NoResults>No results. Try to adjust your filters!</NoResults>
			)}
			{currentPage * pageLength < filteredStories.length && (
				<LoadMore onClick={handleLoadMore}>Load more</LoadMore>
			)}
		</Container>
	);
};

export default Alumni;
